import { ArrowRight, ShieldCheck, Star, Phone } from "lucide-react";
import { BUSINESS, HERO_IMAGE } from "@/lib/config";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative overflow-hidden border-b border-slate-200"
    >
      <div className="bid-grid-bg absolute inset-0 opacity-60" aria-hidden />
      <div className="relative max-w-7xl mx-auto px-6 md:px-10 pt-16 md:pt-24 pb-20 md:pb-28 grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-7 bid-fade-up">
          <div className="flex items-center gap-3 mb-6">
            <span className="bid-divider" />
            <span className="bid-eyebrow">Licensed · Insured · Certified</span>
          </div>

          <h1 className="font-display font-black text-5xl sm:text-6xl lg:text-7xl tracking-tighter uppercase leading-[0.95]">
            Don&apos;t let lint
            <br />
            <span className="text-[#FF2A2A]">ignite.</span>
          </h1>

          <p className="mt-6 text-lg md:text-xl text-slate-700 max-w-xl leading-relaxed">
            Professional dryer vent cleaning that prevents fires, slashes drying
            time, and extends the life of your dryer. Transparent pricing in
            under a minute.
          </p>

          <div className="mt-10 flex flex-wrap gap-4">
            <a
              href="#calculator"
              className="bid-btn-primary"
              data-testid="hero-get-quote-btn"
            >
              Get instant quote
              <ArrowRight size={18} />
            </a>
            <a
              href={`tel:${BUSINESS.phoneRaw}`}
              className="bid-btn-ghost"
              data-testid="hero-book-now-btn"
            >
              <Phone size={16} />
              Call {BUSINESS.phone}
            </a>
          </div>

          <div className="mt-12 grid grid-cols-3 gap-6 max-w-lg">
            <div data-testid="hero-stat-jobs">
              <div className="font-display text-3xl font-black">2,400+</div>
              <div className="text-xs uppercase tracking-widest text-slate-500 mt-1">
                Vents cleaned
              </div>
            </div>
            <div data-testid="hero-stat-rating">
              <a
                href={BUSINESS.googleMapsUrl}
                target="_blank"
                rel="noreferrer"
                className="block group"
              >
                <div className="font-display text-3xl font-black flex items-center gap-1 group-hover:text-[#002FA7] transition-colors">
                  {BUSINESS.googleRating}
                  <Star size={20} fill="#FFC107" stroke="#FFC107" />
                </div>
                <div className="text-xs uppercase tracking-widest text-slate-500 mt-1 group-hover:text-[#002FA7] transition-colors">
                  Google rating
                </div>
              </a>
            </div>
            <div data-testid="hero-stat-guarantee">
              <div className="font-display text-3xl font-black flex items-center gap-1">
                100%
                <ShieldCheck size={20} className="text-[#002FA7]" />
              </div>
              <div className="text-xs uppercase tracking-widest text-slate-500 mt-1">
                Satisfaction
              </div>
            </div>
          </div>
        </div>

        <div className="lg:col-span-5 relative">
          <div className="relative">
            <div
              className="absolute -top-4 -left-4 w-full h-full border-2 border-[#002FA7]"
              aria-hidden
            />
            <img
              src={HERO_IMAGE}
              alt="Clean modern laundry room"
              className="relative w-full h-[420px] md:h-[520px] object-cover"
              data-testid="hero-image"
            />
            <div className="absolute bottom-0 left-0 bg-white border-2 border-slate-900 p-5 max-w-[260px] translate-y-6 -translate-x-6">
              <div className="text-xs uppercase tracking-widest text-slate-500 font-bold">
                Average savings
              </div>
              <div className="font-display text-3xl font-black mt-1">
                $120/year
              </div>
              <div className="text-sm text-slate-600 mt-1">
                in dryer energy costs after cleaning
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
